import type { ProductSchedule, ScheduleStatus } from '@nucleus-commerce/api-client/admin';

type Lifecycle = Pick<ProductSchedule, 'status' | 'runningRunId'>;

export const canActivate = (s: Lifecycle) => s.status === 'draft';
export const canPause = (s: Lifecycle) => s.status === 'active';
export const canResume = (s: Lifecycle) => s.status === 'paused';
/** A claimed run answers 409 CONFLICT, so the button waits for it. */
export const canRunNow = (s: Lifecycle) => s.status === 'active' && s.runningRunId === null;
export const canEnd = (s: Lifecycle) => s.status === 'active' || s.status === 'paused';
/** Only a draft or an ended schedule can be deleted; the others end first. */
export const canDelete = (s: Lifecycle) => s.status === 'draft' || s.status === 'ended';
/** Ended is terminal: settings, pool and preview refuse with 409. */
export const isWritable = (s: Pick<ProductSchedule, 'status'>) => s.status !== 'ended';

export const SCHEDULE_STATUS_ORDER: readonly ScheduleStatus[] = [
  'draft',
  'active',
  'paused',
  'ended',
];

/**
 * When a draft's first run would be if it were activated now (the backend works it out from the
 * cadence and `startsAt`; null once active). On a preview it is the next run when active, the
 * would-be first run for a draft.
 */
export const firstRunAtOf = (source: { firstRunAt: string | null } | null | undefined) =>
  source?.firstRunAt ?? null;
